import * as React from 'react';

import {UsageFooter} from 'shells/navigation/secondary-sidebar/usage-footer-new';

import {useGetUnlockInfo} from '../people-iq/graphql/hooks/use-get-unlock-info';

// The unlock percentage point in which we promote a plan upgrade
const VISITORS_APPROACH_LIMIT_AMOUNT = 0.9;

export function NutshellIqUsageFooter() {
    const {unlockInfo} = useGetUnlockInfo();

    if (!unlockInfo) return null;

    const {unlockLimit, unlockedThisMonth} = unlockInfo;

    return (
        <UsageFooter
            type='visitoriq'
            usage={unlockedThisMonth}
            limit={unlockLimit}
            approachingLimitPercent={VISITORS_APPROACH_LIMIT_AMOUNT}
        />
    );
}
